import { buildSurveyAnswerPayloads } from '../../../shared/utils/surveyAnswers';
import { createRegistrationSurveyResponse } from '../generated/api';
export const submitRegistrationSurveyResponses = async (params) => {
    const { joinCode, surveyUrl, answers } = params;
    const response = await fetch(surveyUrl);
    if (!response.ok) {
        throw new Error('Failed to load survey data');
    }
    const surveyData = (await response.json());
    const payload = {
        joinCode,
        surveyResponse: buildSurveyAnswerPayloads({
            questions: surveyData.questions,
            answers,
        }),
    };
    await createRegistrationSurveyResponse(payload);
};
